
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/quality-engineering",
      function () {
        return require("private-next-pages/services/quality-engineering.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/quality-engineering"])
      });
    }
  